<template>
    <div class="full-view">
        <div class="background" @click="$emit('done')"></div>
        <div class="modal">
            <div class="title">{{$t('accessability.confirm', {location: action.display})}}</div>
            <div class="buttons">
                <button class="button-round" @click="handleAction">OK</button>
                <button class="button-round" @click="$emit('done')">CANCEL</button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        action: Object
    },
    methods: {
        handleAction () {
            this.$router.push(this.action.data);
            this.$emit('done');
        },
        handleKeypress(e) {
            if (e.key === 'Escape')
                this.$emit('done')
            if (e.key === 'Enter')
                this.handleAction()
        },
    },
    mounted () {
        document.addEventListener('keydown', this.handleKeypress, false)
    },
    beforeDestroy () {
        document.removeEventListener('keydown', this.handleKeypress, false)
    }
}
</script>

<style scoped lang='scss'>
    .full-view {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        .background {
            position: absolute;
            z-index: 1;
            background: rgba(97, 97, 97, 0.175);
            width: 100%;
            height: 100%;
        }
        .modal {
            background: white;
            border: 1px solid rgb(212, 212, 212);
            border-radius: 20px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 2;
            width: 30%;
            height: 200px;
            display: flex;
            flex-direction: column;
            
            justify-content: center;
            align-items: center;
            .title {
                font-size: 20px;
                text-align: center;
            }
            .buttons {
                margin-top: 20px;
                width: 100%;
                display: flex;
                justify-content: space-evenly;
            }
        }
    }
</style>